<template>
  <div>
    <breadcrumb/>
    <product-list url="/products/user_products"/>
  </div>
</template>

<script>
import ProductList from "@/components/Products/ProductList";
import Breadcrumb from "@/components/General/Breadcrumb";

export default {
  components: {
    ProductList,
    Breadcrumb
  }
};
</script>

